import Vue from "vue";
import Router from "vue-router";

import WtlRouter from "@/router/router_wtl";
import LxRouter from "@/router/router_lx";
import LdpRouter from "@/router/router_ldp";

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: "/login",
      component: (resolve) => require(["@/pages/login"], resolve),
      meta: {
        title: "登录",
        keepAlive: false,
      },
    },

    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/baseIndex",
      name: "",
      component: (resolve) => require(["@/pages/baseIndex"], resolve),
      meta: {
        title: "",
        keepAlive: false,
      },
      redirect: "/controlPanel",
      children: [
        //数据看板
        {
          path: "/controlPanel",
          component: (resolve) => require(["@/pages/controlPanel"], resolve),
          meta: {
            title: "控制面板",
            keepAlive: true,
          },
        },

        // 天龙的路由
        ...WtlRouter.routerList,

        //刘翔的路由
        ...LxRouter.routerList,

        ...LdpRouter.routerList,
      ],
    },
  ],
});

export default router;
